<template>

  <div class="readingTime">
    <div v-if="isSeen">
      <span class="readingTime_icn"><FaIcon name="check" /></span>
      {{ $t('readingTimeDone') }}
    </div>

    <div v-else>
      <span class="readingTime_icn"><FaIcon name="clock" /></span>
      {{ time }}
    </div>
  </div>

</template>

<script>
import FaIcon from "./FaIcon";
export default {
  name: 'ReadingTime',
  components: {FaIcon},
  props: ['wordsCount', 'isSeen'],
  computed: {
    time: function(){
      const trad = this.$t('readingTime');
      const minutes =  Math.ceil(this.wordsCount / 275);
      return trad.replace('X', minutes) + (minutes > 1 ? 's' : '')
    }
  }
};
</script>

<style scoped lang="scss">
.readingTime{
  color: #000;
  text-align: center;
  height: 3rem;
  line-height: 3rem;
  font-size: 1.2rem;
  font-weight: $FW-medium;

  .readingTime_icn {
    margin-right: 0.5rem;
  }
}
</style>
